// extracted by mini-css-extract-plugin
export default {"screen":"Screen_screen__qkiVV"};